import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/css/font-awesome.min.css";
import "./assets/css/animate.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/bootstrap.min.css";
import "./assets/index.scss";

createApp(App).use(router).mount("#app");
